import * as Sentry from '@sentry/browser';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  setUserId(userId: string): void {
    Sentry.setUser({ id: userId });
  }

  setOperator(operator: string): void {
    Sentry.setTag('operator', operator);
  }

  setWallet(wallet: string): void {
    Sentry.setTag('wallet', wallet);
  }

  setActiveLanguage(language: string): void {
    Sentry.setTag('activeLanguage', language);
  }

  captureException<T extends Record<string, unknown>>(
    error: Error,
    context?: string,
    data?: T,
  ): void {
    Sentry.captureException(error, {
      extra: {
        context,
        ...data,
      },
    });
  }

  addBreadcrumb(name: string, params: object = {}): void {
    Sentry.addBreadcrumb({
      category: 'log',
      message: name,
      data: params,
      level: 'info',
    });
  }
}
